// Wraps useThumbnail, handles fallback to a type-badge placeholder
// when no thumbnail exists (HEIC, video, non-image files).

import { useThumbnail } from "../../hooks/useThumbnail";
import { cn } from "../../lib/utils";

interface Props {
  folderPath: string;
  fileName: string;
  mime?: string;
  className?: string;
}

function extOf(name: string): string {
  const i = name.lastIndexOf(".");
  return i >= 0 ? name.slice(i + 1).toUpperCase() : "FILE";
}

export function Thumbnail({ folderPath, fileName, mime, className }: Props) {
  const url = useThumbnail(folderPath, fileName, mime);
  if (url) {
    return (
      <img
        src={url}
        alt=""
        className={cn("h-full w-full object-cover", className)}
      />
    );
  }
  return (
    <div
      className={cn(
        "flex h-full w-full items-center justify-center bg-white/5 font-mono text-[10px] font-bold tracking-wide text-accent-soft",
        className,
      )}
    >
      {extOf(fileName)}
    </div>
  );
}
